// extracted by mini-css-extract-plugin
export default {"signIn":"sign-in_signIn__cUpPe","intro":"sign-in_intro__jbeJZ","title":"sign-in_title__vUruI","text":"sign-in_text__ZH+3L"};